import React from 'react';
import { Link } from 'react-router-dom';
import './DownloadProfileModal.css';

function DownloadProfileModal({ downloadUrl, onClose }) {
  if (!downloadUrl) {
    return null;
  }

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Login Successful</h3>
          <button className="modal-close" onClick={onClose} aria-label="Close">
            ×
          </button>
        </div>
        <div className="modal-body">
          <p className="modal-description">Download your VPN now !</p>
          <p className="modal-description">Access unlimited worldwide browsing and streaming bandwidth.</p>
          
          <div className="modal-steps">
            <div className="step-item">
              <div className="step-label">Step 1. Download your VPN Profile</div>
              <div className="step-button-container">
                <a 
                  href={downloadUrl} 
                  className="download-vpn-button"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Download VPN Profile
                </a>
              </div>
            </div>
            
            <div className="step-item">
              <div className="step-label">Step 2. Setup Guide</div>
              <div className="step-button-container">
                <Link 
                  to="/guide"
                  className="setup-guide-button"
                  onClick={onClose}
                >
                  View Setup Guide
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DownloadProfileModal;
